const checkOutDiv = document.querySelector('#rk_checkout_div');
const rkFtc = document.querySelectorAll('.rk_rfc_btn')

if(rkFtc.length > 0) {
    checkOutDiv.style.display = 'block';
}

document.addEventListener('rk_cart_event', function (e) {
    checkOutDiv.style.display = 'none';
    location.reload();
}, false);

window.onload = function() {
    const element = document.querySelector('[data-recipient-checkbox]');
    if (element) {
        element.click();
    }
};